// extracted by mini-css-extract-plugin
module.exports = {"wrap_checkbox":"styles_wrap_checkbox__3ixYW","check_mark":"styles_check_mark__7hvED","label":"styles_label__tS-F-","checked":"styles_checked__1TH9P"};